const options = {
  5: "bg-purple-100/5",
  10: "bg-purple-100/10",
  25: "bg-purple-100/25",
  50: "bg-purple-100/50",
  75: "bg-purple-100/75",
  90: "bg-purple-100/90",
  100: "bg-purple-100",
};

const from = {
  5: "from-purple-100/5",
  10: "from-purple-100/10",
  25: "from-purple-100/25",
  50: "from-purple-100/50",
  75: "from-purple-100/75",
  90: "from-purple-100/90",
  100: "from-purple-100",
};

export default function getBackgroundPurple100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
